<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
    <validation-observer ref="simpleRules">
    <b-form @submit.prevent>
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <b-card>
            <b-row>
              <!-- User Info: Left col -->
              <b-col
                cols="21"
                xl="6"
                class="d-flex justify-content-between flex-column"
              >
                <!-- User Avatar & Action Buttons -->
                <div class="d-flex justify-content-start">
                  <b-avatar
                    :src="photo"
                    text="fullname"
                    variant="light-primary"
                    size="104px"
                    rounded
                  />
                  <div class="d-flex flex-column ml-1">
                    <div class="mb-1">
                      <h4 class="mb-0">
                        {{ fullname }}
                      </h4>
                      <span class="card-text">{{ email }}</span>
                    </div>
                    <div class="d-flex flex-wrap">
                      <template v-if="user_profession[0].is_verified === false">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Verifikasi </b-button>
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="warning" class="mr-1" @click.prevent="validationFormReject"> Reject </b-button>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- User Stats -->
                <div class="d-flex align-items-center mt-2">
                  <div class="d-flex align-items-center mr-2">
                    <b-avatar
                      variant="light-primary"
                      rounded
                    >
                      <feather-icon
                        icon="BarChartIcon"
                        size="18"
                      />
                    </b-avatar>
                    <div class="ml-1">
                      <h5 class="mb-0">
                        Status
                      </h5>
                      <small>{{ status }}</small>
                    </div>
                  </div>

                  <div class="d-flex align-items-center">
                    <b-avatar
                      variant="light-success"
                      rounded
                    >
                      <feather-icon
                        icon="SmartphoneIcon"
                        size="18"
                      />
                    </b-avatar>
                    <div class="ml-1">
                      <h5 class="mb-0">
                        Last Phone Access
                      </h5>
                      <small>{{ dateFormat(last_phone_access) }}</small>
                    </div>
                  </div>
                </div>
              </b-col>
              <!-- Right Col: Table -->
              <b-col
                cols="12"
                xl="6"
              >
                <table class="mt-2 mt-xl-0 w-100">
                  <tr>
                    <th class="pb-50">
                      <feather-icon
                        icon="UserIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold">Nama Lengkap</span>
                    </th>
                    <td class="pb-50">
                      {{ fullname }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pb-50">
                      <feather-icon
                        icon="HeartIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold">Kelamin</span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      <template v-if="gender === 'M'">
                        Laki - Laki
                      </template>
                      <template v-else>
                        Perempuan
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th class="pb-50">
                      <feather-icon
                        icon="CalendarIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold">Tempat / Tangga Lahir</span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      {{ birth_place }}. {{ dateDFormat(birth_date) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pb-50">
                      <feather-icon
                        icon="MapIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold">Alamat</span>
                    </th>
                    <td class="pb-50">
                      {{ address }}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <feather-icon
                        icon="PhoneIcon"
                        class="mr-75"
                      />
                      <span class="font-weight-bold">Kontak</span>
                    </th>
                    <td>
                      {{ phone }}
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          lg="6"
        >
        <b-card title="Profession">
          <app-timeline>
            <template v-for="(r_user_profession, index_up) in user_profession">
            <app-timeline-item v-bind:key="index_up">
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <h6><feather-icon icon="BriefcaseIcon" size="13"/> {{ r_user_profession.profession_name }}</h6>
                <!-- <small class="text-muted">12 min ago</small> -->
                <small class="text-secondary">
                  <template v-if="r_user_profession.is_verified === false">
                    <b-badge variant="danger" class="badge-glow">
                      <feather-icon icon="InfoIcon" size="12"/>
                      <span> Belum ter-verifikasi</span>
                    </b-badge>
                    </template>
                    <template v-else-if="r_user_profession.is_verified === true">
                    <b-badge variant="success" class="badge-glow">
                      <feather-icon icon="CheckIcon" size="12"/>
                      <span> ter-verifikasi</span>
                    </b-badge>
                  </template>
                </small>
              </div>
              <p>
                <template v-for="(r_user_profession_specialist, index_s) in r_user_profession.specialist">
                <b-badge variant="info" class="badge-glow" v-bind:key="index_s">
                  {{ r_user_profession_specialist.specialist_name }}
                </b-badge>
                </template>
              </p>
              <p class="mb-0">
                <template v-for="(r_user_profession_document_document, indexsd) in r_user_profession.document">
                <h5 v-bind:key="indexsd" class="text-capitalize mb-75">{{ r_user_profession_document_document.document_name }} </h5>
                <!-- <template v-if="r_user_profession_document_document.profession_document_name === 'Peradi_member_photo_back'"> -->
                <!-- <b-img v-bind:key="indexsd" :src="r_user_profession_document_document.value" rounded fluid alt="profile photo"/> -->
                <!-- </template> -->
                <!-- <template v-else> -->
                <template v-if="r_user_profession_document_document.document_type === 'IMG'">
                  <b-img v-bind:key="indexsd" :src="r_user_profession_document_document.value" rounded fluid alt="profile photo"/>
                </template>
                <template v-else>
                  <b-card-text v-bind:key="indexsd" >
                    {{ r_user_profession_document_document.value }}
                  </b-card-text>
                </template>
                <!-- </template> -->
                </template>
              </p>
            </app-timeline-item>
            </template>
          </app-timeline>
        </b-card>
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
        <b-card title="Kartu Pengenal">
          <b-card-sub-title>{{ id_card_number }}</b-card-sub-title>
          <div class="profile-img mt-2">
            <b-img
              :src="id_card_photo"
              rounded
              fluid
              alt="profile photo"
            />
          </div>
        </b-card>
        </b-col>
      </b-row>
    </b-form>
    </validation-observer>
  </b-overlay>
</template>
<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BImg, BBadge, BAvatar, BListGroup, BListGroupItem, BCardText, BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BCardBody, BCardTitle, BCardSubTitle, } from 'bootstrap-vue'
import { required } from '@validations'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { AppTimeline, AppTimelineItem, AppCollapse, BAvatar, AppCollapseItem, BImg, BBadge, BListGroup, BListGroupItem, BCardText, vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BCardBody, BCardTitle, BCardSubTitle, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      id: '', nameitem: '', address: '', birth_date:'', birth_place:'', created_at:'', deleted_at:'', email:'', firebase_id:'', fullname:'', gender:'', id:'', id_card_number:'', id_card_photo:'', is_choose_profession:'', is_email_verified:'', is_verified:'', last_otp_send:'', last_phone_access:'', name:'', phone:'', photo:'', status:'', updated_at:'', user_id:'', user_profession:'', user_profession_document:'', user_type:'',
      show: false,
      required 
    }
  },
  computed: {
    dateFormat () {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    dateDFormat () {
      return create_at => this.$options.filters.formatDateD(create_at)
    }
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = {id: this.id, url: 'accept'} 
			    this.$store.dispatch('verification/formPostPutProfession', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    validationFormReject () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = {id: this.id, url: 'reject'} 
			    this.$store.dispatch('verification/formPostPutProfession', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('verification/getByProfessionId', id).then(data => {
      this.id = data.user_id
      this.nameitem = data.nameitem
      this.address = data.address
      this.birth_date = data.birth_date
      this.birth_place = data.birth_place
      this.is_verified = data.is_verified
      this.created_at = data.created_at
      this.deleted_at = data.deleted_at
      this.email = data.email
      this.firebase_id = data.firebase_id
      this.fullname = data.fullname
      this.gender = data.gender
      this.id_card_number = data.id_card_number
      this.id_card_photo = data.id_card_photo
      this.is_choose_profession = data.is_choose_profession
      this.is_email_verified = data.is_email_verified
      this.last_otp_send = data.last_otp_send
      this.last_phone_access = data.last_phone_access
      this.name = data.name
      this.phone = data.phone
      this.photo = data.photo
      this.status = data.status
      this.updated_at = data.updated_at
      this.user_id = data.user_id
      this.user_profession = data.user_profession
      this.user_profession_document = data.user_profession_document
      this.user_type = data.user_type
      this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>